import { useQuery, UseQueryOptions } from "@tanstack/react-query";

import { useClient } from "../../ClientContext";
import { PortalClientError } from "../../types";
import { JsonApiResponse } from "../types";
import { OfferStatsCollection, OfferStatsParams } from "./types";

const useOfferImpressionCounts = <
  TData extends {} = JsonApiResponse<OfferStatsCollection>
>(
  offerId: string,
  params: OfferStatsParams,
  queryOptions?: UseQueryOptions<
    JsonApiResponse<OfferStatsCollection>,
    PortalClientError,
    TData
  >
) => {
  const client = useClient();
  return useQuery<
    JsonApiResponse<OfferStatsCollection>,
    PortalClientError,
    TData
  >(
    ["offerImpressionCounts", offerId, params],
    () =>
      client.get(`/offers/${offerId}/daily_impression_counts`, {
        params,
      }),
    {
      refetchOnWindowFocus: false,
      ...queryOptions,
    }
  );
};
export default useOfferImpressionCounts;
